import React, { Component } from 'react';

import '../html-template/styles.css';
import '../html-template/survey.scss';
import '../html-template/tool.scss';
import logo from '../html-template/logo.png';
import info_graphic from '../info_graphic_1.svg';
import {Animated} from "react-animated-css";

import {isEmpty} from 'lodash';
import axios from 'axios';
 

class SurveyScreen extends Component {
    constructor(props){
        super(props);

        this.state = {
            resp: {
                resp_code: '',
                resp_name: '',
                resp_yob: '',
                resp_phone: '',
                inter_code: '',
                resp_city: ''
            },
            current_page: 1,
            num_of_pages: props.num_of_pages ? props.num_of_pages : 3,
            models: [
                {code: '1', name: 'Honda Air Blade'},
                {code: '2', name: 'Honda Future'},
                {code: '3', name: 'Honda Lead'},
                {code: '4', name: 'Honda SH Mode'},
                {code: '5', name: 'Honda SH 125i'},
                {code: '6', name: 'Honda Wave RSX'},
                {code: '7', name: 'Honda Winner'},
                {code: '8', name: 'Honda Vision'},
                {code: '9', name: 'Honda Vairo'},
            ],
						attributes: [
								{code: '1', name: 'Thể thao'},
								{code: '2', name: 'Ngầu - hầm hố'},
								{code: '3', name: 'Thân thiện'},
								{code: '4', name: 'Cứng cáp, chắn chắn'},
								{code: '5', name: 'Nam tính'},
								{code: '6', name: 'Nữ tính, dịu dàng'},
								{code: '7', name: 'Cổ điển'},
								{code: '8', name: 'Mang phong cách tương lai'},
								{code: '9', name: 'Đơn giản'},
								{code: '10', name: 'Hiện đại'},
								{code: '11', name: 'Thời trang'},
								{code: '12', name: 'Sành điệu'},
								{code: '13', name: 'Trẻ trung'},
								{code: '14', name: 'Chững chạc'},
								{code: '15', name: 'Tinh tế'},
								{code: '16', name: 'Mạnh mẽ'},
								{code: '17', name: 'Sang trọng'},
								{code: '18', name: 'Độc đáo, phá cách'},
								{code: '19', name: 'Góc cạnh, đường nét rõ ràng, dứt khoát'},
								{code: '20', name: 'Uốn lượn mềm mại'},
								{code: '21', name: 'Thon gọn, đem lại cảm giác linh hoạt'},
								{code: '22', name: 'Đồ sộ, đem lại cảm giác vững chãi'},
								{code: '23', name: 'Nhiều điểm nhấn, chi tiết nổi bật'},
								{code: '24', name: 'Cao cấp'}
						],
					current_attrs:  [],
            current_model: 0,
            error_message: '',
            colors: [],
            current_color: 0
        }

        this.inputChanged = this.inputChanged.bind(this);
        this.handleModelChange = this.handleModelChange.bind(this);
        this.colorClicked = this.colorClicked.bind(this);
        this.handleNext = this.handleNext.bind(this);

    }

    componentDidMount(){
        axios.get(process.env.PUBLIC_URL + "/assets/json/colors.json")
            .then(resp => {
                this.setState({
                    colors: resp.data
                });
            });
    }

	attrInList(attrs, code){
		return attrs.filter(c => c.code == code).length > 0;
	}
    inputChanged(e){

        const resp = {...this.state.resp};
        resp[e.target.name] = e.target.value;

        this.setState((prev) => {
            return { resp }
        });
    }

    handleModelChange(e){

        this.setState({
            current_model: e.target.value
        });
    }

	handleAttrChange = (code, label) => {

			const {current_attrs} = this.state;
				if(current_attrs.length < 3 && !this.attrInList(current_attrs,code)){
					this.setState((state) => {
						return	{ current_attrs: state.current_attrs.concat([{code: code, label: label}]) }
					});
				}else if(this.attrInList(current_attrs,code)){
						this.setState((state) => {
							return	{ current_attrs: state.current_attrs.filter((el) => el.code != code) }
						});
					}
    }

    colorClicked(e){
        const color_code = e.target.getAttribute('data-code');

        this.setState({ current_color: color_code });
    }

    handleNext(){
        if(this.state.current_page === 1){
            const {resp_code, resp_name, resp_yob, resp_phone, inter_code, resp_city} = this.state.resp;
            if(isEmpty(resp_code) || isEmpty(resp_name) || isEmpty(resp_yob) || isEmpty(resp_phone) || isEmpty(inter_code) || isEmpty(resp_city)){
                this.setState({error_message: "Vui lòng điền đầy đủ thông tin"});
                return;
            }
        }else if(this.state.current_page === 2){
            if(this.state.current_model<=0){
                this.setState({error_message: "Vui lòng chọn một mẫu xe"});
                return;
            }
        }else if(this.state.current_page === 3){
            if(this.state.current_attrs.length!=3){
                this.setState({error_message: "Vui lòng chọn 3 yếu tố"});
                return;
            }
        }else if(this.state.current_page === 4){
            if(this.state.current_color<=0){
                this.setState({error_message: "Vui lòng chọn 3 một màu"});
                return;
            }
        }

        if(this.state.current_page < this.state.num_of_pages){
            this.setState((prev) => {
                if(prev.current_page < prev.num_of_pages){
                    return { current_page: prev.current_page+1, error_message: '' };
                }
            });
        }else{
            this.props.history.push({
                pathname: '/tool',
                state: { 
                    resp: {...this.state.resp},
                    current_model: this.state.current_model,
                    current_color: this.state.current_color,
                    attrs: this.state.current_attrs,
									current_attr: this.state.current_attrs[0]
                }
            });
        }
    }

    render(){
        let question = null;
        const {colors} = this.state;
        if(this.state.current_page === 1){
            question = (
                            <Animated animationIn="fadeInRight" animationOut="fadeOutLeft" animateOnMount={true} isVisible={this.state.current_page === 1 ? true : false} animationInDuration={500} animationOutDuration={500} >
                                <div className="question">
                                    <div className="question__header">
                                        <div className="question__position">1/{this.state.num_of_pages}</div>
                                        <div className="question__title">
                                            Thông tin bảng câu hỏi 
                                        </div>
                                    </div>
                                    <div className="question__options">
                                        <div className="question__form-group">
                                            <input type="text" name="resp_city" className="question__form-element" placeholder="Thành phố: HCM, HN" value={this.state.resp.resp_city} onChange={this.inputChanged}/>
                                        </div>
                                        <div className="question__form-group">
                                            <input type="text" name="resp_code" className="question__form-element" placeholder="Mã số BCH (vd. 200010)" value={this.state.resp.resp_code} onChange={this.inputChanged}/>
                                        </div>
                                        <div className="question__form-group">
                                            <input type="text" name="resp_name" className="question__form-element" placeholder="Tên đáp viên (vd. Nguyen Van A)" value={this.state.resp.resp_name} onChange={this.inputChanged}/>
                                        </div>
                                        <div className="question__form-group">
                                            <input type="text" name="resp_phone" className="question__form-element" placeholder="Số điện thoại (vd. 0932121222)" value={this.state.resp.resp_phone} onChange={this.inputChanged}/>
                                        </div>
                                        <div className="question__form-group">
                                            <input type="number" name="resp_yob" className="question__form-element" placeholder="Năm sinh (vd. 1990)" value={this.state.resp.resp_yob}  onChange={this.inputChanged}/>
                                        </div>
                                        <div className="question__form-group">
                                            <input type="text" name="inter_code" className="question__form-element" placeholder="Mã số phỏng vấn viên (vd. N2123)" value={this.state.resp.inter_code} onChange={this.inputChanged}/>
                                        </div>
                                    </div>
                                </div>
                            </Animated>
            );
        }else if(this.state.current_page === 2){
            question = (
                            <Animated animationIn="fadeInRight" animationOut="fadeOutLeft" animateOnMount={true} isVisible={this.state.current_page === 2 ? true : false} animationInDuration={500} animationOutDuration={500}>
                                <div className="question">
                                    <div className="question__header">
                                        <div className="question__position">2/{this.state.num_of_pages}</div>
                                        <div className="question__title">
                                            Vui lòng chọn một mẫu xe bên dưới
                                        </div>
                                    </div>
                                    <div className="question__options grid-2">
                                        { this.state.models.map((m) =>  
                                        <div key={m.code} className="question__form-group">
                                            <label className="radio-container">
                                                {m.name}
                                                <input type="radio" name="QModel" value={m.code} checked={this.state.current_model === m.code} onChange={this.handleModelChange} />
                                                <span className="checkmark"></span>
                                            </label>
                                        </div>
                                        )
                                        }
                                    </div>
                                </div>
                            </Animated>
            );
        }else if(this.state.current_page === 3){
            question = (
                            <Animated animationIn="fadeInRight" animationOut="fadeOutLeft" animateOnMount={true} isVisible={this.state.current_page === 3 ? true : false} animationInDuration={500} animationOutDuration={500}>
                                <div className="question">
                                    <div className="question__header">
                                        <div className="question__position">{this.state.current_page}/{this.state.num_of_pages}</div>
                                        <div className="question__title">
                                            Ghi nhận 3 yếu tố của đáp viên đã chọn
																					<div className={"subtext" + (this.state.current_attrs.length == 3?" done":"")}>Đã chọn: {this.state.current_attrs.length}/3</div>
                                        </div>
                                    </div>
                                    <div className="question__options grid-2">
                                        { this.state.attributes.map((m) =>  
                                        <div key={m.code} className="question__form-group">
                                            <label className="checkbox-container">
                                                {m.name}
																							<input type="checkbox" name="QAttribute" value={m.code} checked={this.attrInList(this.state.current_attrs, m.code)} onChange={() => this.handleAttrChange(m.code, m.name)} />
                                                <span className="checkmark"></span>
                                            </label>
                                        </div>
                                        )
                                        }
                                    </div>
                                </div>
                            </Animated>
            );

        }else if(this.state.current_page === 4){
           question = ( 
            <Animated animationIn="fadeInRight" animationOut="fadeOutLeft" animateOnMount={true} isVisible={this.state.current_page === 4 ? true : false} animationInDuration={500} animationOutDuration={500}>
                                <div className="question">
                                    <div className="question__header">
                                        <div className="question__position">3/{this.state.num_of_pages}</div>
                                        <div className="question__title">
                                            Nhìn vào bảng màu thật bên ngoài, vui lòng chọn một màu làm màu chủ đạo cho chiếc xe này mà anh chị thích nhất
                                        </div>
                                    </div>
                                    <div className="question__options">
                                        <div className="question__form-group">

                                            {colors.map((color_group) => 
                                            <ul key={color_group[0].Group_Code}className={"paint-tool__color " + (this.state.current_color !== 0 ? "has-selected" : "")}>
                                                { 
                                                    color_group.map((color) => 
                                                        <li key={color.Code}>
                                                            <span 
                                                                className={"color__item " + (this.state.current_color.toString() === color.Code.toString() ? "current" : "")}
                                                                data-code={color.Code} 
                                                                onClick={this.colorClicked} 
                                                                style={{
                                                                    backgroundColor: `hsl(${color.H},${color.S}%,${color.B}%)`,
                                                                    color: color.B < 82 ? '#FFF' : '#333'
                                                                }}>{color.Code}
                                                            </span>
                                                        </li>
                                                    )
                                                }
                                            </ul>
                                            )}
                                        </div>
                                    </div>
                                </div>

            </Animated>
            );
        }
        return (
        <main className="container tool to-mau">
            <div className="span-1-of-2 content-left">
                <div className="content-left-wrapper content-wrapper">
                    <a href="/" title="Cimigo" className="top-logo">
                        <img src={logo} alt="Cimigo" />
                    </a>
                    <div className="content-left__main-body">
                        <figure>
                            <img src={info_graphic} alt="landscape" />
                        </figure>
                        <h2>C8755 Rainbow 23</h2>
                        <p>Mưa cần nắng để thấy cầu vồng. Em cần anh để thấy màu của hạnh phúc.</p>
                    </div>
                    <div className="copy">
                        © 2023 Cimigo
                    </div>
                </div>
            </div>
            <div className="span-1-of-2 content-right content-wrapper">
                <div className="content-right-wrapper survey">
                    <div className="survey__header">
                        <div className="survey__progress-bar" style={{width: (this.state.current_page*100.0/this.state.num_of_pages) + "%"}}>
                        </div>
                    </div>
                    <div id="question-container">
                        <div className="questions">
                            {question}
                        </div>
                        <div className="error-message">
                            {this.state.error_message}
                        </div>
                        <div className="question-container__action-bar">
                            <button className="btn btn--primary" onClick={this.handleNext}>Next</button>
                        </div>
                    </div>
                </div>
            </div>
        </main>
        );
    }
}

export default SurveyScreen;
